import { useForm } from 'react-hook-form';
import {
  AssistantProfileFormValues,
  assistantProfileFormResolver,
} from './schema';

export type AssistantProfileUseForm = ReturnType<
  typeof useForm<AssistantProfileFormValues>
>;

/**
 * Builds the react-hook-form instance for the medical assistant
 * self-service profile form, seeded with empty defaults.
 *
 * @param defaultValues - optional initial values to prefill the form
 * @returns the form instance under `assistantProfileForm`
 */
export const useAssistantProfileForm = (
  defaultValues?: Partial<AssistantProfileFormValues>,
) => {
  const assistantProfileForm = useForm<AssistantProfileFormValues>({
    resolver: assistantProfileFormResolver,
    defaultValues: {
      firstname: '',
      lastname: '',
      phone: '',
      dateOfBirth: '',
      birthPlace: '',
      nationality: '',
      socialSecurityNumber: '',
      addressLine1: '',
      addressLine2: '',
      addressPostalCode: '',
      addressCity: '',
      addressState: '',
      ...defaultValues,
    },
  });

  return { assistantProfileForm };
};
